import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { 
  RiMagicLine, 
  RiSuitcaseLine, 
  RiCloseLine, 
  RiPlaneLine, 
  RiMapPinLine
} from "react-icons/ri";
import "./Holiday.css";

const Holiday = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  
  // State for the Selection Popup
  const [showTypeSelectionModal, setShowTypeSelectionModal] = useState(false);

  // 1. Auth Check
  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }

  // 2. Handlers
  const handleAiPackageClick = () => {
    setShowTypeSelectionModal(true);
  };

  const handleManualPackageClick = () => {
    navigate('/holidaymanualpackage'); // Navigate to Manual Package Route
  };

  const handleSelectFlightPackage = () => {
    setShowTypeSelectionModal(false); 
    navigate('/holidayflightpackage'); // Navigate to Flight Package Route
  };

  const handleSelectLandPackage = () => {
    setShowTypeSelectionModal(false);
    navigate('/holidaylandpackage');   // Navigate to Land Package Route
  };

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      
      <div className="main-content holiday-landing-bg">
        <div className="page-content h-100">
          <div className="container-fluid">
            
            {/* --- LANDING SELECTION (Cards) --- */}
            <div className="h-100 d-flex flex-column justify-content-center align-items-center pt-5">
              <div className="text-center mb-5">
                <h1 className="holiday-title">
                  Zotrai<span className="holiday-text-highlight">Packages</span>
                </h1>
                <p className="holiday-subtitle">
                  Design unforgettable journeys with ease.
                </p>
              </div>

              <div className="row w-100 justify-content-center gap-4">
                {/* AI Package Card */}
                <div className="col-md-5 col-lg-4">
                  <div className="holiday-selection-card holiday-card-ai" onClick={handleAiPackageClick}>
                    <div className="holiday-icon-wrapper holiday-ai-icon-bg">
                      <RiMagicLine className="holiday-card-icon holiday-ai-icon-color" />
                      <div className="holiday-sparkle s1"></div>
                      <div className="holiday-sparkle s2"></div>
                    </div>
                    <h3 className="holiday-card-title">AI Package</h3>
                    <p className="holiday-card-desc">Let our AI architect the perfect itinerary for you in seconds.</p>
                  </div>
                </div>

                {/* Manual Package Card */}
                <div className="col-md-5 col-lg-4">
                  <div className="holiday-selection-card holiday-card-manual" onClick={handleManualPackageClick}>
                    <div className="holiday-icon-wrapper holiday-manual-icon-bg">
                      <RiSuitcaseLine className="holiday-card-icon holiday-manual-icon-color" />
                      <div className="holiday-luggage-accent"></div>
                    </div>
                    <h3 className="holiday-card-title">Manual Package</h3>
                    <p className="holiday-card-desc">Build your custom package from scratch, day by day.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* --- MODAL: AI TYPE SELECTION --- */}
      {showTypeSelectionModal && (
        <div className="holiday-modal-overlay">
          <div className="holiday-modal-content">
            <button className="holiday-modal-close-btn" onClick={() => setShowTypeSelectionModal(false)}>
              <RiCloseLine />
            </button>
            <h2 className="holiday-modal-title">Select Package Type</h2>
            <div className="holiday-modal-options-container">
              <div className="holiday-modal-option-card" onClick={handleSelectFlightPackage}>
                <div className="holiday-modal-icon flight-icon"><RiPlaneLine /></div>
                <span className="holiday-modal-option-text">Flight Package</span>
              </div>
              <div className="holiday-modal-option-card" onClick={handleSelectLandPackage}>
                <div className="holiday-modal-icon land-icon"><RiMapPinLine /></div>
                <span className="holiday-modal-option-text">Land Package</span>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Holiday;